import React from 'react'
import Logo from './Logo'
import Navigation from './Navigation'
import { Link } from "gatsby";

const Index = props => {
  return (
    <nav className="flex items-center justify-between flex-wrap bg-zinc-900/90 border-b border-zinc-700  p-3 fixed w-full z-10 top-0">
      <div className="flex items-center flex-shrink-0 text-white mr-6 ml-6">
        <Link aria-label="Page d'accueil" className="text-white no-underline hover:text-white hover:no-underline " to="/">
          <Logo className="w-16 h-16" />
        </Link>
      </div>

      <div className="flex-grow lg:flex lg:items-center w-auto lg:block pt-0" id="nav-content">
        <Navigation {...props} />
      </div>
    </nav>
  )
}

export default Index
